import { el } from 'redom';

import TextInputBox from 'generics/components/text-input/text-input-box';
import NativeHorizontalToggle from 'generics/components/horizontal-toggle/native';
import CodeEditorInputBoxRow from 'generics/components/code-editor-input-box/row';

import './index.scss';

class AdvancedFormSettings {

  constructor(configuration) {

    this.detailsEditor = configuration.detailsEditor;
    this.data = configuration.data;
    this.onChange = configuration.onChange;

    this.apiEndpointInput = null;
    this.takeActionInputBoxRow = null;

    this.el = el('.advanced-form-settings-main', [
      this.renderForwardAuthorizationTokenInputRow(),
      this.renderNotifyInputRow(),
      this.renderAPIEndpointInputRow(),
      this.renderTakeActionInputRow()
    ]);

  }

  handleAPIEndpointInputClick() {

    this.apiEndpointInput.focus();

  }

  renderAPIEndpointInputRow() {

    this.apiEndpointInput = new TextInputBox({
      label: 'Send form data to',
      placeholder: 'https://api.example.com/submit',
      value: this.data.apiEndpoint,
      onChange: this.handleAPIEndpointInputChange.bind(this)
    });

    return el('.api-endpoint-input-row', {
      class: 'form-input-row'
    }, [
      el('label', 'Send form data to'), el('.api-endpoint-input-control', {
        onclick: this.handleAPIEndpointInputClick.bind(this)
      }, [
        el('label.api-endpoint-method', 'POST'),
        this.apiEndpointInput
      ])
    ]);

  }

  renderForwardAuthorizationTokenInputRow() {

    return el('.required-input-row', {
      class: 'form-input-row'
    }, [
      new NativeHorizontalToggle({
        label: 'Pass user authentication token if logged in',
        value: this.data.forwardAuthorizationToken || false,
        onChange: this.handleForwardAuthorizationTokenChange.bind(this)
      })
    ]);

  }

  renderNotifyInputRow() {

    return el('.required-input-row', {
      class: 'form-input-row'
    }, [
      new NativeHorizontalToggle({
        label: 'Notify',
        value: this.data.notify || false,
        onChange: this.handleNotifyChange.bind(this)
      })
    ]);

  }

  renderTakeActionInputRow() {

    this.takeActionInputBoxRow = new CodeEditorInputBoxRow({
      placeholder: `
      function submittedFormHandler(page, form, submission) {
        // page - current page
        // submission.formId - form id
        // submission.data - form data
        // submission.apiCallResponse - Response of the API call, if the form data is expected to be sent to an API.
        // submission.apiCallResponse.statusCode - HTTP status code
        // submission.apiCallResponse.body - API call response body
        // submission.apiCallResponse.headers - API call response headers
        // Notifier.info('Form is submitted successfully!')
        // Notifier.error('Uh oh! There some error. Please try another time');
      }`,
      label: 'Take action',
      value: this.data.apiResponseHandler,
      onChange: this.handleTakeActionChange.bind(this)
    });

    return this.takeActionInputBoxRow;

  }

  handleAPIEndpointInputChange(event) {

    this.data.apiEndpoint = event.target.value || null;
    this.onChange(this.data);

  }

  handleNotifyChange(notify) {

    this.data.notify = notify;
    this.onChange(this.data);

  }

  handleForwardAuthorizationTokenChange(checked) {

    this.data.forwardAuthorizationToken = checked;
    this.onChange(this.data);

  }

  handleTakeActionChange(code) {

    this.data.apiResponseHandler = code;
    this.detailsEditor.refreshRedirectPath();
    this.onChange(this.data);

  }

  buildAPIResponseHandlerForPath(path) {

    const apiResponseHandler = `
    function submittedFormHandler(submission) {
      window.location.href = '${path}';
    }`;

    this.takeActionInputBoxRow.input.setValue(apiResponseHandler);
    this.handleTakeActionChange(apiResponseHandler);

  }

}

export default AdvancedFormSettings;